module.exports = __webpack_public_path__ + "static/media/lumbering6.2f7eb0a2.jpg";